(function () {
  let hasShown = false;
  let lastFocused = null;
  const popup = document.getElementById('promotional-popup');
  const overlay = document.getElementById('promotional-popup-overlay');
  const closeBtn = document.getElementById('promotional-popup-close');
  const reopenBtn = document.getElementById('promotional-popup-reopen');
  const reopenWrapper = document.getElementById('promotional-popup-reopen-wrapper');
  const reopenCloseBtn = document.getElementById('promotional-popup-reopen-close');
  const SHOW_DELAY_MS = 5000;
  const BUSY_RETRY_MS = 1000;
  // Open states that trap focus, including ones that do not lock scrolling
  // (cart notification) and the menu drawer while it animates open.
  const OPEN_OVERLAY_SELECTOR = [
    'dialog[open]',
    '[aria-modal="true"][open]',
    'modal-dialog[open]',
    'modal-drawer[open]',
    'newsletter-popup[open]',
    'details.menu-opening',
    '#cart-notification.active'
  ].join(', ');

  if (!popup) {
    return;
  }

  function isOpen() {
    return popup.style.display === 'block';
  }

  function openPopup() {
    lastFocused = document.activeElement;
    popup.style.display = 'block';
    if (overlay) overlay.style.display = 'block';
    if (reopenWrapper) reopenWrapper.style.display = 'none';
    // Same scroll-lock class as the theme modals, so other popups know one is open.
    document.body.classList.add('overflow-hidden');
    document.addEventListener('keydown', onKeyDown);
    // trapFocus comes from theme.js; fall back to focusing the dialog itself.
    if (typeof trapFocus === 'function') {
      trapFocus(popup, closeBtn || popup);
    } else {
      popup.focus();
    }
  }

  function showPopup() {
    if (hasShown) return;
    hasShown = true;
    openPopup();
  }

  function hidePopup() {
    popup.style.display = 'none';
    if (overlay) overlay.style.display = 'none';
    if (reopenWrapper && !sessionStorage.getItem('exitPopupReopenClosed')) {
      reopenWrapper.style.display = 'flex';
    }
    document.body.classList.remove('overflow-hidden');
    document.removeEventListener('keydown', onKeyDown);
    // The opener may be hidden by now (e.g. the reopen badge was dismissed).
    const focusTarget = lastFocused && lastFocused.offsetParent !== null ? lastFocused : null;
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(focusTarget);
    } else if (focusTarget && typeof focusTarget.focus === 'function') {
      focusTarget.focus();
    }
  }

  function closePopup() {
    hidePopup();
    markPopupShown();
  }

  function onKeyDown(event) {
    if (event.key === 'Escape' && isOpen()) closePopup();
  }

  function hideReopenButton() {
    if (reopenWrapper) {
      reopenWrapper.style.display = 'none';
      sessionStorage.setItem('exitPopupReopenClosed', '1');
    }
  }

  function shouldShowPopup() {
    return !sessionStorage.getItem('exitPopupShown');
  }

  function markPopupShown() {
    sessionStorage.setItem('exitPopupShown', '1');
  }

  if (closeBtn) closeBtn.addEventListener('click', closePopup);

  if (overlay) overlay.addEventListener('click', closePopup);

  if (reopenBtn) reopenBtn.addEventListener('click', openPopup);

  if (reopenCloseBtn) reopenCloseBtn.addEventListener('click', hideReopenButton);

  // Popup already dismissed this session: show the reopen badge (mobile and desktop).
  if (sessionStorage.getItem('exitPopupShown') &&
      !sessionStorage.getItem('exitPopupReopenClosed') &&
      reopenWrapper) {
    reopenWrapper.style.display = 'flex';
  }

  // Another modal, drawer or menu owns the page (and the global focus trap from theme.js).
  // Scroll locks: overflow-hidden (modals, cart drawer, details modals) and its
  // breakpoint variants overflow-hidden-mobile/-tablet/-desktop (menu drawer, localization).
  function hasScrollLock() {
    return Array.prototype.some.call(document.body.classList, function (className) {
      return className.indexOf('overflow-hidden') === 0;
    }) || document.documentElement.classList.contains('lcp-scroll-lock');
  }

  function isAnotherModalOpen() {
    if (hasScrollLock()) return true;
    return Boolean(document.querySelector(OPEN_OVERLAY_SELECTOR));
  }

  // Auto-open only when nothing else is open; replacing the shared focus trap would
  // leave the underlying modal without keyboard containment once this popup closes.
  function showWhenPageIsFree() {
    if (isAnotherModalOpen()) {
      setTimeout(showWhenPageIsFree, BUSY_RETRY_MS);
      return;
    }
    showPopup();
    markPopupShown();
  }

  if (shouldShowPopup()) {
    setTimeout(showWhenPageIsFree, SHOW_DELAY_MS);
  }
})();
